import { render, staticRenderFns } from "./ReplyMessageCard.vue?vue&type=template&id=31ed82be&scoped=true&"
import script from "./ReplyMessageCard.vue?vue&type=script&lang=js&"
export * from "./ReplyMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./ReplyMessageCard.vue?vue&type=style&index=0&id=31ed82be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed82be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VChip,VCombobox,VDivider,VImg,VSpacer})
